import styled from 'styled-components';

import ResponsiveImg, {
  ValidWidths,
} from '@sorare/core/src/atoms/ui/ResponsiveImg';
import { CARD_SIZE } from '@sorare/core/src/lib/cards';

export type CardImage = {
  pictureUrl?: string | null;
  anyPlayer: {
    displayName: string;
  };
};
type Props = {
  card: CardImage;
  cropWidth?: ValidWidths;
  className?: string;
};

export const CardWrapper = styled.div`
  max-width: ${CARD_SIZE}px;
  aspect-ratio: var(--card-aspect-ratio);
  width: 100%;
`;

const CardImage = styled(ResponsiveImg)`
  width: 100%;
  aspect-ratio: var(--card-aspect-ratio);
`;

export const Card = ({ card, cropWidth = CARD_SIZE, className }: Props) => {
  return (
    <CardWrapper className={className} title={card.anyPlayer.displayName}>
      <CardImage
        loading="lazy"
        cropWidth={cropWidth}
        src={card.pictureUrl!}
        alt=""
        draggable="false"
      />
    </CardWrapper>
  );
};

export default Card;
